import React from "react";
import { ClipboardList, HandPlatter, IndianRupee, Utensils } from "lucide-react";
import haptics from "../../../helpers/haptics";

const MobileBottomNavigation = ({
  currentView,
  onViewChange,
  cartItemCount,
  onCartClick,
}) => {
  const navItems = [
    {
      id: "tables",
      CustomIcon: Utensils,
      label: "Tables",
    },
    {
      id: "orders",
      CustomIcon: ClipboardList,
      label: "Orders",
    },
    {
      id: "home",
      CustomIcon: HandPlatter,
      label: "Active Orders",
    },
    {
      id: "cart",
      CustomIcon: IndianRupee,
      badge: cartItemCount,
    },
  ];

  const handleNavClick = (item) => {
    haptics.medium();
    if (item.id === "cart") {
      onCartClick();
    } else {
      onViewChange(item.id);
    }
  };

  return (
    <div className="mobile-bottom-nav d-flex position-fixed justify-content-around align-items-center px-3 shadow-lg">
      {navItems.map((item) => (
        <button
          key={item.id}
          className={`btn p-0 px-2 py-1 border-0 position-relative ${
            currentView === item.id ? "mobile-nav-active" : "mobile-nav-inactive"
          }`}
          onClick={() => handleNavClick(item)}
        >
          {item.CustomIcon ? <item.CustomIcon size={20}/> : <i className={item.icon}></i>}
          {currentView === item.id && (
            <span className="mobile-nav-dot position-absolute bg-white rounded-circle" />
          )}
          {item.badge > 0 && (
            <span className="mobile-nav-badge position-absolute top-0 start-100 translate-middle badge rounded-pill">
              {item.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default MobileBottomNavigation;

